import React, { useState } from "react";
import { OUTLINE_BTN, CARD_TITLE } from "../utils/styles";

const SalesTeamPerformance = ({ stats }) => {
    const [showAllSales, setShowAllSales] = useState(false);

    const salesTeam = stats?.salesTeamPerformance || [];
    const hasSalesTeam = salesTeam.length > 0;

    // Calculate dynamic totals for the Sales Team Performance table
    const totalCalls = salesTeam.reduce((acc, row) => acc + (row.totalCall || 0), 0);
    const totalConnected = salesTeam.reduce((acc, row) => acc + (row.callInitiate || 0), 0);
    const totalInterested = salesTeam.reduce((acc, row) => acc + (row.interestedInFuture || 0), 0);

    return (
        <div className="card card-custom h-100 shadow-sm border-0 bg-white rounded-lg p-5 p-md-6">
            <div className="card-body p-0">
                <div className="d-flex align-items-center justify-content-between mb-5">
                    <h3
                        className="card-title font-weight-bolder text-dark font-size-h5 m-0"
                        style={CARD_TITLE}
                    >
                        Sales Team Performance
                    </h3>
                    {salesTeam.length > 4 && (
                        <button
                            type="button"
                            onClick={() => setShowAllSales(!showAllSales)}
                            className="btn btn-outline-primary px-3 py-1 rounded-lg font-weight-bolder"
                            style={OUTLINE_BTN}
                        >
                            {showAllSales ? "View Less" : "View All"}
                        </button>
                    )}
                </div>
                <div
                    style={{
                        overflowX: "auto",
                        overflowY: showAllSales ? "auto" : "visible",
                        maxHeight: showAllSales ? "330px" : "none",
                        height: "auto",
                        paddingRight: "8px",
                        scrollbarWidth: "thin",
                        scrollbarColor: "#6f42c1 transparent"
                    }}
                >
                    <table className="table table-borderless table-vertical-center m-0 w-100">
                        <thead style={{ position: showAllSales ? "sticky" : "static", top: 0, zIndex: 10 }}>
                            <tr
                                className="text-dark font-weight-boldest border-bottom border-light"
                                style={{ fontSize: "0.75rem", letterSpacing: "0.5px", color: "#181C32", backgroundColor: "#ffffff" }}
                            >
                                <th className="pl-0 pb-3" style={{ color: "#181C32", backgroundColor: "#ffffff", fontWeight: "700" }}>Team Member</th>
                                <th className="text-center pb-3" style={{ color: "#181C32", backgroundColor: "#ffffff", fontWeight: "700" }}>Calls</th>
                                <th className="text-center pb-3" style={{ color: "#181C32", backgroundColor: "#ffffff", fontWeight: "700" }}>Connected</th>
                                <th className="text-center pb-3" style={{ color: "#181C32", backgroundColor: "#ffffff", fontWeight: "700" }}>Interested</th>
                            </tr>
                        </thead>
                        <tbody>
                            {hasSalesTeam ? (
                                <>
                                    {salesTeam
                                        .filter((row, idx) => (showAllSales ? true : idx < 5))
                                        .map((row, idx) => {
                                            return (
                                                <tr
                                                    key={idx}
                                                    className="border-bottom border-light-soft"
                                                    style={{ transition: "all 0.2s ease", cursor: "pointer" }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor = "rgba(110, 66, 193, 0.03)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor = "transparent";
                                                    }}
                                                >
                                                    <td className="pl-0 py-3 font-weight-boldest text-dark" style={{ fontSize: "0.85rem", color: "#181C32" }}>
                                                        {row.saleName}
                                                    </td>
                                                    <td className="text-center py-3 font-weight-bolder text-dark-75" style={{ fontSize: "0.85rem", color: "#3F4254" }}>
                                                         {(row.totalCall || 0).toLocaleString()}
                                                    </td>
                                                    <td className="text-center py-3 font-weight-bolder text-dark-75" style={{ fontSize: "0.85rem", color: "#3F4254" }}>
                                                        {(row.callInitiate || 0).toLocaleString()}
                                                    </td>
                                                    <td className="text-center py-3 font-weight-bolder text-dark-75" style={{ fontSize: "0.85rem", color: "#3F4254" }}>
                                                        {(row.interestedInFuture || 0).toLocaleString()}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    {/* Total Row */}
                                    <tr style={{ backgroundColor: "#FBF9FF", borderTop: "2px solid #EFEBFC" }}>
                                        <td className="pl-2 py-3 font-weight-boldest text-dark" style={{ fontSize: "0.85rem", color: "#181C32" }}>
                                            Total
                                        </td>
                                        <td className="text-center py-3 font-weight-boldest text-dark" style={{ fontSize: "0.85rem", color: "#181C32" }}>
                                            {totalCalls.toLocaleString()}
                                        </td>
                                        <td className="text-center py-3 font-weight-boldest text-dark" style={{ fontSize: "0.85rem", color: "#181C32" }}>
                                            {totalConnected.toLocaleString()}
                                        </td>
                                        <td className="text-center py-3 font-weight-boldest text-dark" style={{ fontSize: "0.85rem", color: "#181C32" }}>
                                            {totalInterested.toLocaleString()}
                                        </td>
                                    </tr>
                                </>
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center py-10 text-muted font-weight-bold" style={{ fontSize: "0.9rem" }}>
                                        No performance data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default React.memo(SalesTeamPerformance);
